module.exports = __webpack_public_path__ + "img/share.36163f00.png";